import '@app/icare/i18n/i18n'
import { UpdateAvailableContainer } from '@app/icare/components/UpdateAvailableContainer'
import { isDevOrTest } from '@pkg/shared/env'
import { StartClient } from '@tanstack/react-start/client'
import { StrictMode } from 'react'
import { hydrateRoot } from 'react-dom/client'

hydrateRoot(
  document,
  isDevOrTest ? (
    <StrictMode>
      <UpdateAvailableContainer>
        <StartClient />
      </UpdateAvailableContainer>
    </StrictMode>
  ) : (
    <UpdateAvailableContainer>
      <StartClient />
    </UpdateAvailableContainer>
  ),
  {
    // Log the raw Error (with its real stack) instead of only React's
    // component-stack string, which error boundaries otherwise swallow.
    onCaughtError: (error, info) => {
      // biome-ignore lint/suspicious/noConsole: surface the unmasked error stack in DevTools
      console.error('[react:caught]', error, info.componentStack)
    },
    onUncaughtError: (error, info) => {
      // biome-ignore lint/suspicious/noConsole: surface the unmasked error stack in DevTools
      console.error('[react:uncaught]', error, info.componentStack)
    },
  },
)
